import React from 'react';

export default () => {
  return (
    <div className="flex flex-row items-center bg-[#1F1F1F] p-3 rounded-full m-4">
      <img src={'https://padel-if-module.web.app/assets/info_image.svg'} alt="" />
      <div className="info-price-container ml-4">
        <div className="flex flex-row w-full justify-between">
          <div className="flex flex-row items-center">
            <div className="round border-higher-price !ml-0" />
            1000 грн / год
          </div>
        </div>
        <div className="text-base text-white font-extrabold text-[16px]">
          Мінімальний час гри - 1 година
        </div>
      </div>
    </div>
  );
};
